import { Injectable } from '@angular/core';
import { type } from 'jquery';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  AuthhandleError(AuthhandleError) {

    const err = AuthhandleError.error;
    // server-side error
    const errorMessage = `${err.error_description}`;
    return throwError(errorMessage);
  }

  handleError(error) {
    let err = error.error;
    if (typeof (err) === 'object') {
      err = err.Message;
    }
    const errorMessage = `${err}`;
    return throwError(errorMessage);
  }
}
